import { SxProps, Box } from '@mui/material';

type alertBannerProps = {
    sx?: SxProps;
    children?: any;
};

export default function AlertBanner({ sx, children, ...other }: alertBannerProps) {
    return (
        <Box
            sx={{
                padding: '3px 10px',
                textAlign: 'left',
                backgroundColor: 'rgba(0, 171, 85, 0.08)',
                fontSize: '14px',
                fontStyle: 'italic',
                borderRadius: '10px',
                mb: 2,
                ...sx,
            }}
            {...other}
        >
            {children}
        </Box>
    );
}
